import { Component, OnInit , AfterViewInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";

@Component({
    selector: 'app-activity',
    templateUrl: './activity.component.html',
    styleUrls: ['./activity.component.css']
})
export class ActivityComponent implements OnInit , AfterViewInit {
    page: string;
    practiceMetaId: number;
    sub: any;

    constructor(private route: ActivatedRoute,
                private router: Router) { }

    ngOnInit() {
        this.sub = this.route.params.subscribe(params => {
            this.practiceMetaId = params['practiceMetaId'];
        });

        this.page = "introduction";
    }

    ngAfterViewInit(){
        let html=document.documentElement;
        /*var htmlFontSize=html.clientWidth/7.5;*/
        let htmlFontSize;
        if(window.screen.width<window.screen.height){
            htmlFontSize = window.screen.width/ 7.5;
        }else{
            htmlFontSize = window.screen.height/ 7.5;
        }
        html.style.fontSize=htmlFontSize+"px";
        html.style.backgroundColor="#2c2c50";
    }

    onSuccess() {
      this.page = "success";
    }

    onApply() {
        if (this.practiceMetaId > 0) {
            var link = [this.practiceMetaId, 'case-practice'];
            this.router.navigate(link);
        }
        else {
            this.page = "form";
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/activity.component.ts